import React from 'react'
import { PortableText, PortableTextBlock } from '@portabletext/react'
import {
  FAQComponents,
  HelpCenterComponents,
  OpportunityDetailComponents,
} from './richtext-components-config'

interface RichTextRendererProps {
  content: PortableTextBlock[]
  variant?: 'FAQ' | 'help-center' | 'opportunity-details'
}

const RichTextRenderer = ({ content, variant }: RichTextRendererProps) => {
  let customComponents

  switch (variant) {
    case 'FAQ':
      customComponents = FAQComponents
      break
    case 'help-center':
      customComponents = HelpCenterComponents
      break
    case 'opportunity-details':
      customComponents = OpportunityDetailComponents
      break
    default:
      customComponents = {}
      break
  }

  return <PortableText value={content} components={customComponents} onMissingComponent={false} />
}

export { RichTextRenderer }
